export const GET_PUSH_NOTIFICATION_LIST = null;
export const GET_SENT_PUSH_NOTIFICATION_LIST = null;